import _debounce from 'lodash/debounce';
import Component from 'component';

class HeaderBrandSwitcher extends Component {
  constructor(el) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      $navWrapper: this.$el.find('.header-brand-switcher__nav-wrapper'),
      $switcherNav: this.$el.find('.header-brand-switcher__nav'),
      $logosWrapper: this.$el.find('.header-brand-switcher__logos-wrapper'),
      $leftShadow: this.$el.find('.header-brand-switcher__shadow-left'),
      $rightShadow: this.$el.find('.header-brand-switcher__shadow-right'),
      $switcherImages: this.$el.find('.header-brand-switcher__item-image'),
      $switcherLinks: this.$el.find('.header-brand-switcher__item-link')
    };
    this.initTable();
  }

  initTable() {

    const navWidth = this.dom.$logosWrapper[0].scrollWidth;
    const containerWidth = this.dom.$switcherNav[0].offsetWidth;
    this.tableScrollWidth = navWidth - containerWidth;
    this.dom.$logosWrapper[0].scrollLeft = 0;
    this.isScrollable = false;
    if (this.tableScrollWidth !== 0) {
      this.isScrollable = true;
      this.dom.$logosWrapper.css('cursor', 'grab')
    } else {
      this.dom.$logosWrapper.css('cursor', null)
    }

    const color = this.$el.css('background-color').split('(')[1].replace(')', '').split(',')

    this.dom.$leftShadow.css('background', `linear-gradient(to right, 
      rgba(${color[0]}, ${color[1]}, ${color[2]}, 0.98) 5%, 
      rgba(${color[0]}, ${color[1]}, ${color[2]}, 0.8) 40%, 
      rgba(${color[0]}, ${color[1]}, ${color[2]}, 0) 100%)`);


    this.dom.$rightShadow.css('background', `linear-gradient(to left, 
      rgba(${color[0]}, ${color[1]}, ${color[2]}, 0.98) 5%, 
      rgba(${color[0]}, ${color[1]}, ${color[2]}, 0.8) 40%, 
      rgba(${color[0]}, ${color[1]}, ${color[2]}, 0) 100%)`);

    if (!this.dom.$navWrapper.hasClass('header-brand-switcher__nav-wrapper--no-first-logo')){
      this.dom.$leftShadow.css('left', `${this.dom.$switcherLinks[0].offsetWidth}px`)
    }


    this.dom.$switcherImages.attr('draggable', 'false')
    this.dom.$switcherImages.attr('ondragstart', 'return false;')

    this.dom.$switcherLinks.attr('draggable', 'false')
    this.dom.$switcherLinks.attr('ondragstart', 'return false;')

    this.dragging = false;

    if (this.tableScrollWidth <= 0) {
      this.dom.$leftShadow[0].style.visibility = 'hidden';
      this.dom.$rightShadow[0].style.visibility = 'hidden';
    } else {
      this.dom.$leftShadow[0].style.visibility = 'hidden';
      this.dom.$rightShadow[0].style.visibility = 'visible';
      this.dom.$switcherLinks.css('cursor', 'grab');
    }

  }

  addListeners() {
    this.dom.$logosWrapper.on('scroll', ::this.handleScroll);

    document.addEventListener('mousedown', ::this.handleMouseDown);
    document.addEventListener('mousemove', ::this.handleMouseMove);
    document.addEventListener('mouseup', ::this.handleMouseUp);

    window.addEventListener('resize', _debounce(::this.handleResize, 300));
  }

  setActionState(){
    const atStart = this.scrollPosition === 0;
    const atEnd = this.scrollPosition === 1;

    this.dom.$leftShadow[0].style.opacity = atStart ? '0' : '1';
    this.dom.$leftShadow[0].style.visibility = atStart ? 'hidden' : 'visible';

    this.dom.$rightShadow[0].style.opacity = atEnd ? '0' : '1';
    this.dom.$rightShadow[0].style.visibility = atEnd ? 'hidden' : 'visible';
  }

  handleResize(){
    this.initTable();
  }

  handleScroll() {

    const navWidth = this.dom.$logosWrapper[0].scrollWidth;
    const containerWidth = this.dom.$switcherNav[0].offsetWidth;

    this.tableScrollWidth = navWidth - containerWidth;
    this.scrollPosition = this.dom.$logosWrapper[0].scrollLeft/this.tableScrollWidth;

    if (this.scrollPosition < 0) {
      this.scrollPosition = 0;
    }
    if (this.scrollPosition > 1) {
      this.scrollPosition = 1;
    }

    if (this.isScrollable) this.setActionState();
  }

  handleMouseDown(e) {
    if (this.dom.$switcherNav[0].contains(e.target) && this.isScrollable) {
      this.dragging = true;
      this.mousePosition = e.clientX;
    }
  }

  handleMouseMove(e) {
    if (this.dragging && this.isScrollable) {
      this.dom.$logosWrapper.css('cursor', 'grabbing')
      this.dom.$switcherLinks.css('pointer-events', 'none')
      const delta = e.clientX - this.mousePosition;
      this.mousePosition = e.clientX;
      this.dom.$logosWrapper[0].scrollLeft -= delta
      this.setActionState();
    }
  }

  handleMouseUp() {
    this.dragging = false;
    this.dom.$switcherLinks.css('pointer-events', 'auto')
    this.dom.$logosWrapper.css('cursor', 'grab')

  }

}

export default HeaderBrandSwitcher;



// WEBPACK FOOTER //
// ./src/tc/js/components/HeaderBrandSwitcher.js